import moment from "moment";
import { holidayList } from "../../helpers/Holidays";

/* The holiday list lives on the client, so it is sent to the API rather than
   duplicated there — one list, used by the calendar, the dashboard and here. */
export const holidayKeys = () =>
    holidayList.map((h) => moment(h.date, "DD/MM/YYYY").format("YYYY-MM-DD")).join(",");

/* What a holiday is actually called. The server is told which dates are
   holidays but not their names, and the names are worth having on the
   calendar — so they are looked up here, from the same list the dashboard's
   "Holidays, Weekly Offs" section reads. Dates are DD/MM/YYYY in that file. */
const holidayNames = holidayList.reduce((all, entry) => {
    all[moment(entry.date, "DD/MM/YYYY").format("YYYY-MM-DD")] = entry.holiday;
    return all;
}, {});

export const holidayNameOf = (dateKey) => holidayNames[dateKey] || "Holiday";

export const hm = (minutes) => {
    const m = Math.max(Math.round(minutes || 0), 0);
    return `${Math.floor(m / 60)}h ${m % 60}m`;
};

export const timeOf = (value) => (value ? moment(value).format("h:mm A") : "--");

/* The calendar cell has room for a few characters, so a round day reads "8h"
   and anything else keeps its fraction: "7.5h". */
export const hmShort = (minutes) => {
    const m = Math.max(Math.round(minutes || 0), 0);
    if (!m) return "";
    const hours = m / 60;
    return `${Number(hours.toFixed(1))}h`;
};

export const STATUS = {
    present: { label: "Present", tone: "wh-pill-good" },
    partial: { label: "Partial", tone: "wh-pill-warn" },
    absent: { label: "Absent", tone: "wh-pill-danger" },
    leave: { label: "On leave", tone: "wh-pill" },
    holiday: { label: "Holiday", tone: "wh-pill" },
    weekend: { label: "Weekly-off", tone: "wh-pill-quiet" },
    upcoming: { label: "Upcoming", tone: "wh-pill-quiet" },
};

/* The colours the calendar is read by. Leave and holiday are drawn apart, as
   they are on the dashboard — one is time somebody took, the other a day the
   company closed. Everything else sits outside them, in grey. */
export const LEGEND = [
    { status: "present", label: "Present" },
    { status: "partial", label: "Partial day" },
    { status: "leave", label: "Leave" },
    { status: "holiday", label: "Holiday" },
    { status: "absent", label: "Absent" },
    /* not a status of its own — a marker any day can carry while a manager
       has yet to decide on it */
    { status: "requested", label: "Requested" },
];

/* rows arrive oldest first; this keeps that order within each month */
export const groupByMonth = (rows = []) => {
    const months = [];
    const seen = {};

    rows.forEach((row) => {
        const monthKey = moment(row.date).format("YYYY-MM");
        if (!seen[monthKey]) {
            seen[monthKey] = {
                key: monthKey,
                label: moment(row.date).format("MMMM YYYY"),
                /* Monday-first, matching the weekday header */
                lead: (moment(row.date).startOf("month").day() + 6) % 7,
                days: [],
                workedMinutes: 0,
                presentDays: 0,
            };
            months.push(seen[monthKey]);
        }
        const month = seen[monthKey];
        month.days.push(row);
        month.workedMinutes += row.grossMinutes || 0;
        if (["present", "partial"].includes(row.status)) month.presentDays += 1;
    });

    return months;
};

/* what both tabs open on: the current month, whole */
export const DEFAULT_RANGE_MONTHS = 1;

export const defaultRange = () => ({
    from: moment().subtract(DEFAULT_RANGE_MONTHS - 1, "months").startOf("month").toDate(),
    to: moment().endOf("month").toDate(),
});

export const apiDate = (value) =>
    (value && moment(value).isValid() ? moment(value).format("YYYY-MM-DD") : "");
